import React from 'react'

import PersonCoverageModal from 'components/PersonCoverageModal'

const HOSPITAL_INDEMNITY_COVERAGE_DESCRIPTION =
  'We’ll calculate your hospital indemnity plan pricing based on who you want to cover. Use the checkboxes and click “Save” to make any changes.'

const HospitalIndemnityCoverageModal = (props) => (
  <PersonCoverageModal description={HOSPITAL_INDEMNITY_COVERAGE_DESCRIPTION} {...props} />
)

HospitalIndemnityCoverageModal.displayName = 'HospitalIndemnityCoverageModal'

export default HospitalIndemnityCoverageModal
